<template>
    <header>
        <div class="desktop_nav">
            <router-link to="/" class="name_header" title="Link zur Startseite" @click="activeNav = '99';">Anika Wagner</router-link>
            <router-link to="/" class="logo_header" title="Startseite" @click="activeNav = '99';"><img :src="require('@/assets/' + awImgSrc)" alt="AW in gemalten Farben"/></router-link>
            <nav class="navigation">
                <ul class="nav_list">
                    <li><router-link to="/galerie" :class="{'nav_link':true, 'active':(activeNav.value === '0')}" @click="activeNav = '0'">Galerie</router-link></li>
                    <li><router-link to="/ueberMich" :class="{'nav_link':true, 'active':(activeNav.value === '1')}" @click="activeNav = '1'">Über mich</router-link></li>
                    <li><router-link to="/kontakt" :class="{'nav_link':true, 'active':(activeNav.value === '2')}" @click="activeNav = '2'">Kontakt</router-link></li>
                    <li><router-link to="/impressum" :class="{'nav_link':true, 'active':(activeNav.value === '3')}" @click="activeNav = '3'">Impressum</router-link></li>
                </ul>
            </nav>
        </div>

        <div class="mobile_navigation">
            <a href="./index.html" class="name_header" title="Link zur Startseite" @click="activeNav = '99';">Anika Wagner</a>
            <a href="./index.html" class="logo_header" title="Startseite" @click="activeNav = '99';"><img :src="require('@/assets/' + awImgSrc)" alt="AW in gemalten Farben"/></a>
            <nav>
                <input type="checkbox" id="hamburg" v-model="showMobileNav" @click="toggleShowMobileNav()"/>
                <label for="hamburg" class="hamburg">
                    <span class="line"></span>
                    <span class="line"></span>
                    <span class="line"></span>
                </label>
            </nav>
        </div>
        <Transition name="fade">
            <ul id="mobile_nav_list" v-if="showMobileNav">
                <li><router-link to="/galerie" :class="{'nav_link':true, 'active':(activeNav.value === '0')}" @click="toggleShowMobileNav(); activeNav = '0';">Galerie</router-link></li>
                <li><router-link to="/ueberMich" :class="{'nav_link':true, 'active':(activeNav.value === '1')}" @click="toggleShowMobileNav(); activeNav = '1';">Über mich</router-link></li>
                <li><router-link to="/kontakt" :class="{'nav_link':true, 'active':(activeNav.value === '2')}" @click="toggleShowMobileNav(); activeNav = '2';">Kontakt</router-link></li>
                <li><router-link to="/impressum" :class="{'nav_link':true, 'active':(activeNav.value === '3')}" @click="toggleShowMobileNav(); activeNav = '3';">Impressum</router-link></li>
            </ul>
        </Transition>
    </header>
</template>

<script lang="ts">
    import { defineComponent, inject, computed } from 'vue';

    export default defineComponent({
    name: 'AW-menu',
    props: {
        awImgSrc: String,
        activeItem: String,
    },
    setup() {
        const activeNavItem = inject("activeNavItem") as string;
        const updateNavItem = inject("updateNavItem") as any;
        const activeNav = computed({
            get: () => activeNavItem,
            set: updateNavItem,
        });
        return {
            activeNav
        };
    },
    data() {
        return {
            showMobileNav: false,
            active: this.activeItem 
        }
    },
    methods: {
      toggleShowMobileNav() {
            this.showMobileNav = this.showMobileNav ? false : true;
      },
      setActiveItem(item: string) {
          this.active = item;
      },
      test() {
          console.log(this.activeNav);
      }
    }
    });
</script>

<style>
header {
    font-family: 'Yantramanav', sans-serif;
    font-size: 1.25rem;
    font-weight: 300;
    display: flex;
    flex-direction: column;
    background-color:#1F1F1F;
    width: 100%;
    z-index: 1;
    padding-left: calc(100vw - 100%);
    padding-right: 0px;
    border-bottom: 0.5px solid var(--global-color);
}

.logo_header {
    width: 100%;
    height: 30px;
    text-decoration: none;
    color: indianred;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: -30px;
}

.logo_header img {
    height: 35px;
    width: auto;
}

.name_header {
    width: 100%;
    color: var(--global-color);
    text-decoration: none;
    padding-left: 15px;
    font-weight: 200;
    white-space: nowrap;
    font-size: 1.8rem;
}

.impressum {
    position: absolute;
    right: 30px;
    text-decoration: none;
    color: rgb(197, 197, 197);
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.navigation {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
}

.navigation ul, .mobile_navigation ul {
    list-style: none;
    height: 100%;    
    margin: 0;
    padding: 0;
    overflow: hidden;
    margin-left: -14px;
}

.navigation li, .mobile_navigation li {
    float: left;
}

.navigation li a, .mobile_navigation li a {
    display: block;
    color: var(--global-color);
    text-align: center;
    margin-left: 15px;
    margin-right: 15px;
    text-decoration: none;
    cursor: default;
}

.nav_link {
    position: relative;
}

.nav_link:after {    
    background: none repeat scroll 0 0 transparent;
    bottom: 0;
    content: "";
    display: block;
    height: 2px;
    left: 50%;
    position: absolute;
    background: var(--global-color);
    transition: width 0.2s ease 0s, left 0.2s ease 0s;
    width: 0;
  }

.nav_link:hover:after { 
    width: 100%; 
    left: 0; 
}

.active:after{
    background: none repeat scroll 0 0 transparent;
    bottom: 0;
    content: "";
    display: block;
    height: 2px;
    left: 0;
    position: absolute;
    background: var(--global-color);
    width: 100%;
}

.desktop_nav {
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.mobile_navigation {
    display: none;
}

.nav_show {   
    height: 400px !important;
}

.header_height {
    height: 800px !important;
}

@media only screen and (max-width: 1224px) {
    body {
        font-size: 14px !important;
    }

    header {
        top: 0;
        height: auto;
    }

    .desktop_nav {
        display: none;
    }

    .impressum {        
        top: 22px;
    }

    .logo_header {
        margin-left: -120px;
    }

    .logo_header img {        
        height: 60px !important;
    }

    .name_header {
        width: auto;
        font-size: 2.1rem;
    }

    .navigation {
        display: none;
    }

    .mobile_navigation {
        height: 85px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        font-size: 1rem;
    }
    
    #mobile_nav_list {
        display: flex;
        list-style: none;
        position: relative;      
        margin: 0;
        padding: 0;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        transition: all 0.4s ease-in-out;
        height: 380px;
        background-color: #1F1F1F;
        overflow: hidden;
    }
    
    #mobile_nav_list li a {
        display: block;
        color: var(--global-color);
        text-align: center;
        font-size: 1.7rem;
        padding: 20px;
        text-decoration: none;
        cursor: default;
    }

    .fade-enter-active,
    .fade-leave-active {
        transition: all 0.4s ease-in-out;
        max-height: 400px;
    }

    .fade-enter-from,
    .fade-leave-to {
        opacity: 0;
        max-height: 0;
    }
    
    label.hamburg { 
        display: block;        
        width: 95px; 
        height: 80px; 
        position: relative; 
        margin-left: auto; 
        margin-right: 15px;
        margin-bottom: 20px;
        margin-top: 40px;
        border-radius: 4px; 
        transition: border-radius .5s;
     }
     
     .line { 
        position: absolute; 
        left:10px;
        height: 5px; 
        width: 65px; 
        background: var(--global-color); 
        border-radius: 2px;
        display: block; 
        transition: 0.5s; 
        transform-origin: center; 
     }
     
     .line:nth-child(1) { top: 6px; }
     .line:nth-child(2) { top: 24px; }
     .line:nth-child(3) { top: 42px; }
     
     input#hamburg {display:none}

     #hamburg:checked + .hamburg .line:nth-child(1){
        transform: translateY(17px) rotate(-45deg);
     }
     
     #hamburg:checked + .hamburg .line:nth-child(2){
        opacity:0;
     }
     
     #hamburg:checked + .hamburg .line:nth-child(3){
        transform: translateY(-17px) rotate(45deg);
     }     
}

@media only screen and (max-width: 735px) {
    .logo_header > img {
        display: none;
    }
}
</style>